import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  ColumnDetails,
  GetRowsRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { PhasrRecommendationsEndpoint, PhasrRecommendationsMethod } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { GetRecommendationsResponse, GetRowsResponse } from '../types/phasr-recommendations-grid-responses';
import { Column, ColumnKeys } from '../types/grid';
import { API_TYPE_PHASR } from '../../../webcomponents.constants';
import { saveViewState } from '../../../utils/states.utils';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../../grid/gridView/types';

export class PhasrRecommendationsGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private cachedGetPackagesResponse?: GetRecommendationsResponse;
  private readonly allColumnDetails: {};
  public companyFilterDataProvider = API_TYPE_PHASR;
  public readonly viewStateName = 'phasr-phasrViewState';

  constructor(public dependencies: any, allColumnDetails: ColumnDetails<Column, ColumnKeys>[]) {
    super();
    this.allColumnDetails = allColumnDetails.reduce((acc, curr) => ({...acc, [curr.key]: curr}), {});
  }

  private async getRecommendations(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetRecommendationsResponse> {
    return await ConsoleRequest.createRequest<GetRecommendationsResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        page: request.pageNumber ?? DEFAULT_PAGE_NUMBER,
        limit: request.pageSize ?? DEFAULT_PAGE_SIZE,
        sort: request.sortColumnName ?? '',
        dir: request.sortDirection ?? '',
        companyId: request.filters[0].company?.exactMatch ?? '',
        filter: convertGridFiltersToExtJsFilters(request.filters),
      },
      endpoint: PhasrRecommendationsEndpoint.RECOMMENDATION_STATE,
      method: PhasrRecommendationsMethod.READ_RECORDS,
    });
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    this.cachedGetPackagesResponse = await this.getRecommendations(request);
    if (!this.cachedGetPackagesResponse) {
      this.cachedGetPackagesResponse = await this.getRecommendations(request);
      console.error('no cached Packages readRecords response');
    }

    return {
      summary: '',
      numItems: this.cachedGetPackagesResponse.total,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetRowsResponse> {
    if (!this.cachedGetPackagesResponse) {
      this.cachedGetPackagesResponse = await this.getRecommendations(request);
      console.error('no cached Packages readRecords response');
    }

    return {
      success: true,
      rawEvents: this.cachedGetPackagesResponse.data,
    };
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    saveViewState(request, this.viewStateName);
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    saveViewState(request, this.viewStateName);
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
